import types from '../mutation-types';
import ConversationApi from '../../api/inbox/conversation';
import { debounce } from '@chatwoot/utils';
import {
  UNREAD_TAB,
  unreadMeta,
  unreadMetadataScope,
} from 'dashboard/routes/dashboard/unread/policy';

const state = {
  mineCount: 0,
  unAssignedCount: 0,
  allCount: 0,
  unreadCount: 0,
  unreadTabEnabled: false,
  unreadMetaRequestId: 0,
};

export const getters = {
  getStats: $state => $state,
};

// Create a debounced version of the actual API call function
const fetchMetaData = async (commit, params, isCurrentUnreadScope) => {
  try {
    const response = await ConversationApi.meta(params);
    const {
      data: { meta },
    } = response;
    if (!isCurrentUnreadScope()) return;
    commit(types.SET_CONV_TAB_META, meta);
  } catch (error) {
    // ignore
  }
};

const debouncedFetchMetaData = debounce(fetchMetaData, 1000, false, 5000);
const longDebouncedFetchMetaData = debounce(fetchMetaData, 7500, false, 20000);
const superLongDebouncedFetchMetaData = debounce(
  fetchMetaData,
  15000,
  false,
  30000
);

const metaDebouncers = {
  default: debouncedFetchMetaData,
  long: longDebouncedFetchMetaData,
  superLong: superLongDebouncedFetchMetaData,
};

// allCount is 0 until a meta request succeeds; under load it stays 0, so treat
// the unknown case as a large account and poll slowest instead of fastest.
export const getMetaDebounceKey = allCount => {
  if (allCount > 2000 || allCount === 0) return 'superLong';
  if (allCount > 100) return 'long';
  return 'default';
};

export const actions = {
  disableUnread({ commit }) {
    commit('DISABLE_UNREAD_TAB');
  },
  get: ({ commit, state: $state, rootGetters }, params) => {
    commit('START_UNREAD_META_REQUEST');
    const requestId = $state.unreadMetaRequestId;
    const accountId = rootGetters?.getCurrentAccountId;
    const scope = unreadMetadataScope(params);
    const isCurrentUnreadScope = () => {
      const current = rootGetters?.getChatListFilters;
      if (current?.assigneeType !== UNREAD_TAB) return true;
      return (
        requestId === $state.unreadMetaRequestId &&
        accountId === rootGetters?.getCurrentAccountId &&
        scope === unreadMetadataScope(current)
      );
    };
    metaDebouncers[getMetaDebounceKey($state.allCount)](
      commit,
      params,
      isCurrentUnreadScope
    );
  },
  set({ commit }, meta) {
    commit(types.SET_CONV_TAB_META, meta);
  },
};

export const mutations = {
  START_UNREAD_META_REQUEST($state) {
    $state.unreadMetaRequestId = ($state.unreadMetaRequestId || 0) + 1;
  },
  DISABLE_UNREAD_TAB($state) {
    $state.unreadCount = 0;
    $state.unreadTabEnabled = false;
  },
  [types.SET_CONV_TAB_META](
    $state,
    {
      mine_count: mineCount,
      unassigned_count: unAssignedCount,
      all_count: allCount,
      ...meta
    } = {}
  ) {
    Object.assign($state, unreadMeta(meta));
    $state.mineCount = mineCount;
    $state.allCount = allCount;
    $state.unAssignedCount = unAssignedCount;
    $state.updatedOn = new Date();
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
